import { ICPADto } from 'api/cpa/dtos'
import { mapCPAFromDto } from 'api/cpa/helpers'
import http from '../http'
import { IOrganizationDto } from './dtos'
import { mapOrganizationFromDto } from './helpers'
import { ICreateOrganizationParams, IOrganization, IRemoveOrganizationMemberParams } from './models'

const organizationsAPI = http.createClient(`${process.env.NEXT_PUBLIC_API_URL}/organizations`)

export const getOrganizationById = async (id: IOrganization['id']) => {
	const { data } = await organizationsAPI.get<IOrganizationDto>(`/${id}`)
	return mapOrganizationFromDto(data)
}

export const getOrganizationMembers = async (id: IOrganization['id']) => {
	const { data } = await organizationsAPI.get<ICPADto[]>(`/${id}/members`)
	return data.map(mapCPAFromDto)
}

export const createOrganization = async (params: ICreateOrganizationParams) => {
	const { data } = await organizationsAPI.post<IOrganizationDto>('', params)
	return mapOrganizationFromDto(data)
}

export const removeOrganizationById = async (id: IOrganization['id']) => {
	const { data } = await organizationsAPI.delete(`/${id}`)
	return data
}

export const removeOrganizationMember = async (params: IRemoveOrganizationMemberParams) => {
	const { data } = await organizationsAPI.delete(`/${params.orgId}/members/${params.userId}`)
	return data
}
